/* globals SALESFORCE_SCRIPT_URL */
/* eslint-disable jsx-a11y/anchor-is-valid, no-script-url, class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import {observable, reaction} from 'mobx';
import {observer, inject} from 'mobx-react';
import {withRouter, locationShape} from 'react-router';
import autobind from 'autobind-decorator';

import {browserOnly} from 'spa/Components/EnvSplit';
import {withConfig, withI18n} from './Context';

const isServer = typeof window === 'undefined';

const ENVIRONMENT = isServer ? process.env.NODE_ENV : window.ENV;

const CHAT_CONFIG = {
  staging: {
    CHAT_SCRIPT_URL: 'https://urbanco--partialcpy.sandbox.my.site.com/ESWMessagingUserWebsite1735010539095/assets/js/bootstrap.min.js',
    CHAT_ENVIRONMENT_ID: '00DUE000001FwG7',
    CHAT_PLATFORM_ID: 'Messaging_User_Website_Client',
    CHAT_DEPLOYMENT_URL: 'https://urbanco--partialcpy.sandbox.my.site.com/ESWMessagingUserWebsite1735010539095',
    CHAT_SRC_URL: 'https://urbanco--partialcpy.sandbox.my.salesforce-scrt.com',
  },
  production: {
    CHAT_SCRIPT_URL: 'https://urbanco.my.site.com/ESWCustomerWebsite1738086514019/assets/js/bootstrap.min.js',
    CHAT_ENVIRONMENT_ID: '00D0N000000gJ18',
    CHAT_PLATFORM_ID: 'Customer_Website',
    CHAT_DEPLOYMENT_URL: 'https://urbanco.my.site.com/ESWCustomerWebsite1738086514019',
    CHAT_SRC_URL: 'https://urbanco.my.salesforce-scrt.com',
  },
};

const CHAT_ENVIRONMENT_CONFIG = ENVIRONMENT === 'production' ? CHAT_CONFIG.production : CHAT_CONFIG.staging;

@browserOnly
@withRouter
@inject(({
  store: {
    initialLoadComplete,
    screen,
    session,
    tracker,
  },
}) => (
  {
    initialLoadComplete,
    screen,
    session,
    tracker,
  }
))
@observer
@withI18n
@withConfig
class SalesforceChatButton2025 extends React.Component {
  static propTypes = {
    initialLoadComplete: PropTypes.bool,
    location: locationShape.isRequired,
    screen: PropTypes.shape({
      isDesktop: PropTypes.bool,
    }).isRequired,
    session: PropTypes.object,
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
  };

  UNSAFE_componentWillMount() {
    const {location} = this.props;

    if (location && location.pathname.indexOf('/lp/') >= 0) {
      this.isLandingPage = true;
    }
  }

  componentDidMount() {
    if (!window._laq) { window._laq = []; }

    const {session} = this.props;
    const {user} = session;

    this.listeners = [
      reaction(
        () => this.props.initialLoadComplete,
        (initialLoadComplete) => {
          if (initialLoadComplete) {
            const userId = (user && user.id) || undefined;

            this.timeout = setTimeout(() => {
              this.loadChat(userId);
            }, 1000);
          }
        },
        {
          fireImmediately: true,
          name: 'Check if content has finished loading',
        },
      ),
      reaction(
        () => session && session.user && session.user.id,
        (id) => {
          this.loadChat(id);
        },
        {
          name: 'Create chat session when user signs in',
        },
      ),
    ];
  }

  componentWillUnmount() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = undefined;
    }
  }

  @observable isUserChat = false;
  @observable showChatOfflinePopup = false;
  @observable isChatOpen = false;
  @observable hasStartedChat = false;

  /*
   *  This function adds a new script from url parameter to the document head and allows a callback
   *  to be called once the script loads
   */
  loadScript(url, callback) {
    const script = document.createElement('script');
    script.type = 'text/javascript';

    if (script.readyState) { //IE
      script.onreadystatechange = () => {
        if (
          script.readyState === 'loaded' ||
          script.readyState === 'complete'
        ) {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else { //Others
      script.onload = () => {
        callback();
      };
    }

    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  /*
   *  Reload the Salesforce Live Agent
   */
  @autobind
  loadChat(userId) {
    this.loadScript(CHAT_ENVIRONMENT_CONFIG.CHAT_SCRIPT_URL, () => {
      try {
        window.addEventListener('onEmbeddedMessagingReady', () => {
          const pageURL = window.location.href; // Use this for the full URL

          window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
            Platform: 'CLIENT WEBSITE',
            UMUserID: `${userId}`,
            Location: pageURL,
          });
          // Lets populate the Images used for the Messaging Chat branding with our static resources
          const brandings = window.embeddedservice_bootstrap.settings.embeddedServiceConfig.branding;

          for (let i = 0; i < brandings.length; i++) {
            if (brandings[i].n === 'logoImage') {
              brandings[i].v = 'https://res.cloudinary.com/huxr6hrje/image/upload/v1734957989/chat-2025/UM_Chat_Logo.png';
            } else if (brandings[i].n === 'avatarImage') {
              brandings[i].v = 'https://res.cloudinary.com/huxr6hrje/image/upload/v1734957989/chat-2025/UM_Agent_Neutral.png';
            } else if (brandings[i].n === 'botImage') {
              brandings[i].v = 'https://res.cloudinary.com/huxr6hrje/image/upload/v1738687559/chat-2025/prod/botimage1.png';
            }
          }
        });

        window.embeddedservice_bootstrap.settings.language = 'en_US'; // For example, enter 'en' or 'en-US'

        window.embeddedservice_bootstrap.init(
          CHAT_ENVIRONMENT_CONFIG.CHAT_ENVIRONMENT_ID,
          CHAT_ENVIRONMENT_CONFIG.CHAT_PLATFORM_ID,
          CHAT_ENVIRONMENT_CONFIG.CHAT_DEPLOYMENT_URL,
          {
            scrt2URL: CHAT_ENVIRONMENT_CONFIG.CHAT_SRC_URL,
          },
        );
      } catch (err) {
        console.error('Error loading Embedded Messaging: ', err);
      }
    });
  }

  render() {
    return (
      <div />
    );
  }
}

export default SalesforceChatButton2025;



// WEBPACK FOOTER //
// ./spa/Components/SalesforceChatButton2025.jsx